import { useContext } from "react";
import HandlerContext from "search-filter/contexts/HandlerContext";
const useHandlerContext = () => useContext(HandlerContext);
export default useHandlerContext;
